var _circle, _polygon, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDescription1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_Layer_",
    "data-name": "<Layer>",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31,
    fill: "#e3f2fd"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "36.92 44.35 36.92 25.36 23.14 25.36 23.14 29.31 27.29 29.31 27.29 44.35 23.14 44.35 23.14 48.43 41.17 48.43 41.17 44.35 36.92 44.35",
    fill: "#1e88e5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.16,22.48A4.46,4.46,0,1,0,27.7,18,4.46,4.46,0,0,0,32.16,22.48Z",
    fill: "#1e88e5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription1);
export default __webpack_public_path__ + "static/media/description_1.f18cc260771f45265996d1459b57e096.svg";
export { ForwardRef as ReactComponent };